import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { HoldingFormProps } from './index';

export const HOLDING_DIALOG = 'HOLDING_DIALOG';

export const dispatchHoldingFormDialog = (props?: HoldingFormProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: HOLDING_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchHoldingFormDialog;
